<div class="container" [class.mobile]="isMobile">
  <div class="padding-container">
    <div class="back-button wire-btn" (click)="navigateBack()">
      <img class="arrow" src="../../../assets/Discover/Icon-Arrow-Left.svg" alt="arrow" />{{'Retour' | translate}}
    </div>
    <div class="admin-buttons" *ngIf="isAdmin">
      <button class="wire-btn skalaki" (click)="discoverModal()">Edit</button>
      <button class="wire-btn" (click)="deleteDiscover()">Delete</button>
    </div>
    <div class="place" *ngIf="discover">
      <div class="header">
        <div class="title">{{getDiscoverTitle(discover)}}</div>
        <div class="discover-icon" *ngIf="discover.distance">
          <div class="popover-content">
            {{'Distance depuis Skalaki' | translate}}
          </div>
          <div class="pic">
            <img src="../../../assets/Discover/icon_distance.png" alt="personnes">
          </div>
          <div class="description">
            {{discover.distance}}
          </div>
        </div>
        <div class="discover-icon" *ngIf="discover.distanceDuration">
          <div class="popover-content">
            {{'Durée du trajet en voiture' | translate}}
          </div>
          <div class="pic">
            <img src="../../../assets/Discover/icon_distance_duration.png" alt="personnes">
          </div>
          <div class="description">
            {{discover.distanceDuration}}
          </div>
        </div>
        <div class="discover-icon" *ngIf="discover.duration">
          <div class="popover-content">
            {{'Durée du trajet à pied' | translate}}
          </div>
          <div class="pic">
            <img src="../../../assets/Discover/icon_duration.png" alt="personnes">
          </div>
          <div class="description">
            {{discover.duration}}
          </div>
        </div>
      </div>
      <div class="title">Description</div>
      <div class="description-slideshow">
        <div class="description" [innerHTML]="getDiscoverProperty(discover, 'description')">
        </div>
        <div *ngIf="hasPicture" class="slideshow" [class.mobile]="isMobile">
          <div class="gallery-container">
            <app-gallery [pictures]="currentGallery" (onPictureClick)="showPreview($event)"></app-gallery>
          </div>
          <div class="video" *ngIf="discover.videoUrl">
            <video controls controlsList="nodownload">
              <source [src]="discover.videoUrl" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
      <app-preview *ngIf="isPreview"></app-preview>

      <div class="title">
        {{ 'Localisation' | translate}}
        <a *ngIf="discover.gpxUrl" class="wire-btn skalaki" [href]="discover.gpxUrl"
          [download]="getDiscoverGpxUrl(discover)">
          {{'Fichier GPX' | translate}}
        </a>
      </div>
      <div class="map">
        <iframe class="map-frame" allow="geolocation" title="Location" allowfullscreen
          [src]="discover.safeUrl"></iframe>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog header="Delete Place" icon="pi pi-exclamation-triangle"></p-confirmDialog>